import { createSlice,createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import {BASE_URL} from '../../utils/commonUrl'
const initState = {
    isLoading:false,
    message:'',
    assestment:[]
}

export const fetchassestment = createAsyncThunk('assestment/getall', async () => {
    const response = await axios.get(`${BASE_URL}/api/assestment`)
    return response.data
  })


let userSlice = createSlice({
  name:'assestment',
  initialState:initState,
  extraReducers:(builder)=>{
      builder
      .addCase(fetchassestment.pending,(state)=>{
          state.isLoading = true
      })
      .addCase(fetchassestment.fulfilled,(state,action)=>{
          state.isLoading = false
          state.assestment = action.payload
      })
      .addCase(fetchassestment.rejected,(state,payload)=>{
          state.isLoading = false
          state.message = payload.data.message
      })

  },
  reducers:{
      
  
  }
})

//export const {} = userSlice.actions;

export default userSlice.reducer;